export const Page404 = () => {
  return (
    <div className="h-screen w-screen d-flex flex-column justify-content-md-center align-items-center h4 text-center">
      <h1 className="h1">404</h1>
      The page you were requesting is not available.
      <a href="/dashboard">Return to dashboard</a>
    </div>
  );
};
